import { EVALUATION_KIND_MAP } from 'services/graduate-enrollment/evaluations';
import { Space } from 'antd';
import { TextField } from '@refinedev/antd';
import { parseToDayjs } from 'services/date';
import type { IClassroomEvaluation } from 'interfaces/classrooms';

export interface EvaluationsHeaderProps {
  evaluationData: IClassroomEvaluation;
}

const EvaluationsHeader = ({ evaluationData }: EvaluationsHeaderProps) => {
  const rules = evaluationData.requirements?.[0]?.rules ?? [];
  const firstKey = rules[0]?.key;

  const findRuleValue = (operator: 'after' | 'before') =>
    rules.find(r => r.operator === operator)?.value;

  const isPossession = firstKey === 'possession_date';

  const rangePossessionDays = (op: 'after' | 'before') => {
    if (op === 'after') {
      return Number(findRuleValue(op)) / 1440;
    }

    return (
      Number(findRuleValue(op)) / 1440 - Number(findRuleValue('after')) / 1440
    );
  };

  const rangeDate = (op: 'after' | 'before') => {
    const raw = findRuleValue(op);
    return raw ? parseToDayjs(String(raw), 'DD/MM/YYYY') : null;
  };

  return (
    <Space wrap size="middle">
      <TextField
        value={
          evaluationData.evaluation_type === 'Assessment'
            ? `Tipo: Avaliação ${
                EVALUATION_KIND_MAP[evaluationData.evaluation_kind]
              }`
            : 'Tipo: Atividade'
        }
      />

      {/* Peso (omitido se for prova final) */}
      {evaluationData.kind !== 'final' && (
        <TextField value={`Peso: ${evaluationData.weight}`} />
      )}

      {/* Nota mínima */}
      <TextField value={`Nota mínima: ${evaluationData.passing_score}`} />

      {/* Tentativas */}
      <TextField value={`Tentativas: ${evaluationData.max_attempts}`} />

      {/* Faixa de acesso */}
      {isPossession ? (
        <>
          <TextField
            value={`Dias para início: ${rangePossessionDays('after')}`}
          />
          <TextField
            value={`Dias após início: ${rangePossessionDays('before')}`}
          />
        </>
      ) : (
        <TextField
          value={`Acesso: ${rangeDate('after')} - ${rangeDate('before')}`}
        />
      )}
    </Space>
  );
};

export default EvaluationsHeader;
